
import { deleteTemplate, DialogHandler, ListTemplateModel, TemplateModel } from '@cakemail-org/ui-components-v2'
import { t } from 'i18next'
import { showDeleteDialog } from '../../components/dialogs/deleteDialog'

export function showDeleteTemplateDialog({ template }: { template: TemplateModel | ListTemplateModel }): Promise<any> {
    let cbtnRef: any = {}
    return showDeleteDialog({ name: template.name, resourceKey: "resource-name-template-txt" })
        .then(({ event, btnRef }) => {
            cbtnRef = btnRef
            cbtnRef.animate()
            return template.delete()
        }).then(() => {
            DialogHandler.show({
                isExpress: true,
                type: "success",
                title: t("general-resource-deleted", { resource: t("general-template_one") })
            })
            return
        }).catch((e) => {
            if (e) {
                DialogHandler.show({
                    isExpress: true,
                    type: "warning",
                    title: t("template-delete-error")
                })
            }
            throw e
        })
}

